// @flow
import * as React from "react";
import { rgba } from "polished";
import styled from "styled-components";
import Icon from "../Icons/SocialTrading";

export const SocialTradingContext = React.createContext([false, () => {}]);

const SocialTradingIcon = styled(Icon)`
  flex-grow: 0;
  flex-shrink: 0;
`;

const Button = styled.button`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  margin-right: 10px;
  color: ${({ theme, isOpen }) =>
    isOpen ? "#fff" : rgba(theme.foreground, 0.5)};
  background-color: ${({ theme, isOpen }) =>
    isOpen ? theme.bottomNavigationBg : rgba("#919191", 0.59)};
  border: none;
  border-radius: 4px;
  cursor: pointer;
  z-index: 210;
  transition: all 0.3s ease;

  :hover {
    color: ${({ theme, isOpen }) => (isOpen ? "#fff" : theme.foreground)};
  }
`;

type Props = {
  className?: string,
  onClick: () => void,
  isOpen?: boolean,
  replace?: boolean,
  to?: string,
  as?: mixed
};

const ToggleSocial = (props: Props) => (
  <Button
    className={props.className}
    as={props.as}
    isOpen={props.isOpen}
    onClick={props.onClick}
    replace={props.replace}
    to={props.to}
  >
    <SocialTradingIcon width="18px" />
  </Button>
);

export default ToggleSocial;



// WEBPACK FOOTER //
// ./src/components/SocialTrading/ToggleSocial.js